import type { RegisterFormBaseProps } from './RegisterFormBase/RegisterFormBase';

import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from 'react-google-recaptcha-v3';

import { getEnv } from '../../lib/env';

import RegisterFormBase from './RegisterFormBase/RegisterFormBase';

const RegisterFormWithRecaptcha = (props: RegisterFormBaseProps) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  return <RegisterFormBase {...props} executeRecaptcha={executeRecaptcha} />;
};

const RegisterForm = ({
  onSubmit,
  prefilledEmail = '',
  testId,
}: RegisterFormBaseProps) => {
  const recaptchaSiteKey = getEnv('VITE_RECAPTCHA_SITE_KEY');

  if (recaptchaSiteKey) {
    return (
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaSiteKey}
        scriptProps={{ async: true, defer: true }}
      >
        <RegisterFormWithRecaptcha
          onSubmit={onSubmit}
          prefilledEmail={prefilledEmail}
          testId={testId}
        />
      </GoogleReCaptchaProvider>
    );
  }

  return (
    <RegisterFormBase
      onSubmit={onSubmit}
      prefilledEmail={prefilledEmail}
      testId={testId}
    />
  );
};

export default RegisterForm;
